import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import authService from 'store/auth/service';
import { LoginPage } from 'routes/paths';
import { LoaderArrow } from 'components/Loaders/LoaderArrow';

export const LogoutPage = () => {
  const navigate = useNavigate();
  const [logout] = authService.useLogoutMutation();

  useEffect(() => {
    (async () => {
      await logout();
      window.analytics.reset();
      navigate(LoginPage);
    })();
  }, []);

  return <LoaderArrow>Logout...</LoaderArrow>;
};
